import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { AboutusComponent } from './about_us/aboutus.component';
//import { CommonModule } from './common/common.module';
import { CommonComponent } from './common/common.component';
import { IndustriesComponent } from './industries/industries.component';
import { ProductsComponent } from './products/products.component';
import { ContactusComponent } from './contact_us/contactus.component';


const appRoutes: Routes = [

  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'aboutus',
    component: AboutusComponent
  },
  {
    path: 'home',
    component: CommonComponent
  },
   {
    path: 'industries',
    component: IndustriesComponent
  },
   {
    path: 'products',
    component: ProductsComponent
  },
   {
    path: 'contactus',
    component: ContactusComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,{ useHash: true })
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts